import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'Home',
  component: () => import('../views/home/index.vue')
}, {
  path: '/column',
  name: 'Column',
  component: () => import('../views/column/index.vue')
}, {
  path: '/article',
  name: 'Article',
  component: () => import('../views/article/index.vue')
}]

const router = new VueRouter({ routes })

export default router
